import { useEffect, useMemo, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

// project imports
import ListingTable from 'components/table/ListingTable';
import AddEmployeeModal from 'components/warehouse/AddEmployeeModal';
import { fetchEmployeeListing, setSelectedEmployee } from 'store/employeeSlice';

// assets
import ArrowLeftOutlined from '@ant-design/icons/ArrowLeftOutlined';
import EyeOutlined from '@ant-design/icons/EyeOutlined';
import PlusOutlined from '@ant-design/icons/PlusOutlined';

export default function EmployeeListing() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const rows = useSelector((state) => state.employee.rows);
  const status = useSelector((state) => state.employee.status);
  const employeeWarehouseId = useSelector((state) => state.employee.warehouseId);
  const total = useSelector((state) => state.employee.pagination.total);
  const [page, setPage] = useState(1);
  const limit = 10;
  const [addModalOpen, setAddModalOpen] = useState(false);
  const loading = status === 'loading';
  const listedRows = String(employeeWarehouseId) === String(id) ? rows : [];

  const refetchEmployees = () => {
    if (id) {
      dispatch(fetchEmployeeListing({ warehouseId: id, page, limit }));
    }
  };

  const columns = useMemo(
    () => [
      { id: 'full_name', label: 'Name' },
      { id: 'phone', label: 'Phone' },
      { id: 'person_type', label: 'Designation' },
      {
        id: 'action',
        label: 'Action',
        align: 'center',
        render: (row) => (
          <Tooltip title="View">
            <IconButton
              size="medium"
              color="primary"
              onClick={() => {
                dispatch(setSelectedEmployee(row));
                navigate(`/wareHouse/details/${id}/employees/details/${row.id}`);
              }}
            >
              <EyeOutlined />
            </IconButton>
          </Tooltip>
        )
      }
    ],
    [id, navigate]
  );

  useEffect(() => {
    if (!id) return;
    dispatch(fetchEmployeeListing({ warehouseId: id, page, limit }));
  }, [dispatch, id, page]);

  return (
    <Grid container rowSpacing={2}>
      <Grid size={12}>
        <Stack direction="row" alignItems="center" spacing={1.5} flexWrap="wrap">
          <Button
            startIcon={<ArrowLeftOutlined />}
            onClick={() => navigate(`/wareHouse/details/${id}`)}
            sx={{ textTransform: 'none' }}
          >
            Back
          </Button>
          <Typography variant="h4">Employee listing</Typography>
        </Stack>
      </Grid>
      <Grid size={12}>
        <ListingTable
          columns={columns}
          rows={loading ? [] : listedRows}
          rowKey="id"
          searchPlaceholder="Search by name, phone, designation..."
          emptyMessage={loading ? 'Loading...' : 'No employees found'}
          showSearch
          showExport={false}
          rowsPerPage={limit}
          page={page}
          totalCount={total}
          onPageChange={setPage}
          // toolbarLeft={
          //   <Button
          //     variant="contained"
          //     startIcon={<PlusOutlined />}
          //     onClick={() => setAddModalOpen(true)}
          //     sx={{ textTransform: 'none' }}
          //   >
          //     Add Employee
          //   </Button>
          // }
        />
      </Grid>
      <AddEmployeeModal
        open={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        warehouseId={id}
        onCreated={refetchEmployees}
      />
    </Grid>
  );
}
